import { InstanceScreen } from 'component/navigation/instance';

export default function ArticleIndexScreen() {
    return <InstanceScreen />;
}
